import React from 'react';

const NewsFeedScreen = () => {
	return <div>NewsFeedScreen</div>;
};

export default NewsFeedScreen;
